export function hasOverflowingText(el: HTMLElement, document: Document) {
  const clone: HTMLElement = el.cloneNode(true) as HTMLElement;
  clone.style.display = 'inline';
  clone.style.width = 'auto';
  clone.style.maxWidth = 'none';
  clone.style.visibility = 'hidden';
  clone.style.position = 'absolute';
  clone.style.top = '0px';

  if (window.getComputedStyle) {
    const computedStyles: CSSStyleDeclaration = window.getComputedStyle(el);
    clone.style.fontSize = computedStyles.fontSize;
    clone.style.fontWeight = computedStyles.fontWeight;
  }

  document.body.append(clone);

  const ellipsized = clone.offsetWidth > el.offsetWidth;

  document.body.removeChild(clone);

  return ellipsized;
}

export function focusFirstErrorField(keys: string[]) {
  const firstErrorField = keys
    .map(fieldName => document.querySelector(`[id="${fieldName}"]`))
    .filter(elem => elem !== null)
    .sort((a, b) => {
      if (!!a && !!b) {
        // eslint-disable-next-line no-bitwise
        return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
      }

      return -1;
    })[0];

  if (firstErrorField) {
    (firstErrorField as HTMLElement).focus();
  }
}
